var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-close-modal bg-deep-dark rounded-circle d-flex justify-content-center align-items-center",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])
}
var staticRenderFns = []

export { render, staticRenderFns }